import { render, staticRenderFns } from "./ang-form.vue?vue&type=template&id=05ab18b6&"
import script from "./ang-form.vue?vue&type=script&lang=js&"
export * from "./ang-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports